// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import PerformanceConversionFormModal from './FormModal';
import PerformanceConversionForm from './Form';

export default class PerformanceWhatsappFormApp extends Component {
  render() {
    return (
      <PerformanceConversionFormModal
        openModalTriggerSelector={this.props.openModalTriggerSelector}
      >
        <PerformanceConversionForm
          channel={this.props.channel}
          product={this.props.product}
          category={this.props.category}
          brand={this.props.brand}
          link={this.props.link}
          formId={this.props.formId}
          cloneId={this.props.cloneId}
          buttonLabel={this.props.buttonLabel}
          showCpf={this.props.showCpf}
          showUnits={this.props.showUnits}
          showContactOptions={this.props.showContactOptions}
          showEmail={this.props.showEmail}
          showDataPermissions={this.props.showDataPermissions}
          dataPermissionsCustomText={this.props.dataPermissionsCustomText}
          linkPrivacyPolicy={this.props.linkPrivacyPolicy}
          units={this.props.units}
          unit={this.props.unit}
          versions={this.props.versions}
          showVehicleInExchangeField={this.props.showVehicleInExchangeField}
          showContactError={this.props.showContactError}
        />
      </PerformanceConversionFormModal>
    );
  }
}

PerformanceWhatsappFormApp.defaultProps = {
  openModalTriggerSelector: null,
  buttonLabel: 'Converse agora!',
  showContactOptions: true,
  unit: '',
  showContactError: false,
};

PerformanceWhatsappFormApp.propTypes = {
  openModalTriggerSelector: PropTypes.string,
  formId: PropTypes.string,
  cloneId: PropTypes.string,
  buttonLabel: PropTypes.string,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  link: PropTypes.string,
  showCpf: PropTypes.bool,
  showUnits: PropTypes.bool,
  showContactOptions: PropTypes.bool,
  showEmail: PropTypes.bool,
  linkPrivacyPolicy: PropTypes.string,
  showVehicleInExchangeField: PropTypes.bool,
  showDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  unit: PropTypes.string,
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  showContactError: PropTypes.bool,
};
